var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcInactiveSealing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "doc-api-svg--paths",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.0004 8.68994V3.99994H15.3104L12.0004 0.689941L8.69043 3.99994H4.00043V8.68994L0.69043 11.9999L4.00043 15.3099V19.9999H8.69043L12.0004 23.3099L15.3104 19.9999H20.0004V15.3099L23.3104 11.9999L20.0004 8.68994ZM18.0004 14.4799V17.9999H14.4804L12.0004 20.4799L9.52043 17.9999H6.00043V14.4799L3.52043 11.9999L6.00043 9.51994V5.99994H9.52043L12.0004 3.51994L14.4804 5.99994H18.0004V9.51994L20.4804 11.9999L18.0004 14.4799ZM12.0004 6.49994C8.97043 6.49994 6.50043 8.96994 6.50043 11.9999C6.50043 15.0299 8.97043 17.4999 12.0004 17.4999C15.0304 17.4999 17.5004 15.0299 17.5004 11.9999C17.5004 8.96994 15.0304 6.49994 12.0004 6.49994ZM12.0004 15.4999C10.0704 15.4999 8.50043 13.9299 8.50043 11.9999C8.50043 10.0699 10.0704 8.49994 12.0004 8.49994C13.9304 8.49994 15.5004 10.0699 15.5004 11.9999C15.5004 13.9299 13.9304 15.4999 12.0004 15.4999Z",
    fill: "#0033AD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 14C13.1046 14 14 13.1046 14 12C14 10.8954 13.1046 10 12 10C10.8954 10 10 10.8954 10 12C10 13.1046 10.8954 14 12 14Z",
    fill: "#0033AD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcInactiveSealing);
export default __webpack_public_path__ + "static/media/ic_inactive_sealing.043e94662e20f3bda61385ad0c48c6bc.svg";
export { ForwardRef as ReactComponent };